// Data types inputed here must match those expected by the R&A Player Portals API
// The pp_mapByNestedKeys function will map the flat keys
// to nested keys as expected types that are defined in this object.
export const pp_onlineEntryCreationDefaultValues = {
  onlineEntry: {
    onlineEntriesId: 0,
    firstName: '',
    lastName: '',
    birthdate: new Date(),
    emailAddress: '',
    agentEmailAddress: '',
    addressHouseName: '',
    addressFirstLine: '',
    addressSecondLine: '',
    addressTown: '',
    addressCounty: '',
    addressCountry: 0,
    addressCountryObject: {
      id: '',
      name: '',
      numericIso: '',
      countryId: '',
    },
    addressPostCode: '',
    phoneNumber: '',
    phoneCountryCode: '',
    mobilePhoneNumber: '',
    mobilePhoneCountryCode: '',
    nationality: 0,
    nationalityObject: {
      id: '',
      name: '',
      numericIso: '',
      countryId: '',
    },
    handicapCategory: '',
    handicapCertificate: null,
    regionalQualifyingVenue1: 0,
    regionalQualifyingVenue2: 0,
    preferredLengthUnit: '',
    finalQualifyingPref1: 0,
    finalQualifyingPref2: 0,
    finalQualifyingPref3: 0,
    finalQualifyingPref4: 0,
    pgaTour: [],
    golfClub: '',
    isExempt: 0,
    dateAdded: new Date().toISOString(),
    amPro: '',
    caddieName: '',
    caddieEmail: '',
    requiredLocalCaddy: false,
    cdhNumber: '',
    entryFeeAmount: 0,
    isEntryFeePaid: false,
    privacyPolicyAccepted: false,
    privacyPolicyAcceptedUnder18: false,
    acceptedTermsAndConditions: false,
    acceptedTermsUnder18: false,
    exemptionCategories: [],
    exemptionCategoriesFQ: [],
    championshipId: 0, // TO_DO what value? set in hidden field
    isoCountryCode: 0,
    externalID: '',
    externalSystem: '',
    externalSystemOther: '',
    productId: '',
    handicapEmailRecipient: '',
    parentName: '',
    parentEmail: '',
    parentPhone: '',
    parentPhoneCountryCode: '',
    parentRelationship: '',
  },
  referrer: '',
};
